import { apiMiddleware } from 'redux-api-middleware';
import { loadableReady } from '@loadable/component';
import ReactCriteo from '../lib/utils/criteo';
import ReactGTM from '../lib/utils/gtm';
import Router from '../common/components/Router';
import entryPoint from './renderEntryPoint';
import hot from './hot-loader';

if (window) {
  const {
    auth,
    config,
  } = window.PreloadedState;

  if (config.criteo) {
    ReactCriteo.initialize(config.criteo);
  }

  if (config.gtm) {
    ReactGTM.initialize(config.gtm, auth && auth.account_id);
  }

  // https://webpack.js.org/guides/public-path/#on-the-fly
  // eslint-disable-next-line babel/camelcase, no-undef
  __webpack_public_path__ = config.publicPath;
}

const render = () => entryPoint({
  router: hot(Router),
  initialState: window.PreloadedState,
  apiMiddleware,
});

loadableReady(() => {
  render();
});
